<template>
<div class="block-info-base-wrap">

</div>
</template>

<script>
export default {
  data () {
    return {

    }
  }
}
</script>
<style lang="scss" scoped>

</style>
